export default{
  goodsDetails:{
    breadcrumb:{
      home:"首页",
      all:"全部商品"
    },
    BaseInfo:{
      label:{
        outputUnit:"日供应量",
        outputUnit1:"供应量",
        price:"指导价",
        depositPercent:"保证金",
        serviceList:"提供服务",
        reight:"交易运费",
        count:"采购数量",
        orderPay:"下单支付",
        origin:'产地',
        ExpCountry:'出口国',
        supplyCycleType:"供应周期",

      },
      value:{
        egotiable:"面议",
        serviceList:["协助找车","买家自提","物流配送"],
        reight:"双方洽谈",
        canBuy:"库存数量：",
        money:"元",
        noStock:"无库存"
      },
      tips:{
        delist:"该商品已下架",
      }
    },
    TradeFlow:{
      title:"交易流程",
      steps:["选择商品","提交订单","支付订单","支付保证金","支付尾款","商家发货/放货","确认收货/提货","交易成功"],
      tips:{
        title:"提示：",
        items:["1.如需要开票，请在交易成功后前往“个人中心-发票管理”申请开票。","2.为保证商品运输时效，下单成功后请按照约定时间支付尾款。"]
      }
    },
    Button:{
      goBuy:"立即购买",
      car:"加入进货单",
      collect:"收藏",
      collected:"已收藏",
      sampleGobuy:"样品下单",
      customer:"联系客服",
      collectShopDel:"取消关注",
      collectShop:"关注店铺",
      goToShop:"进入店铺",
      soldOut:"已售罄",
      sampleAppletUrl:"样品邮寄"
    },
    DetailsInfo:{
      title:"商品详情",
      categoryName:"品类",
      brand:"品牌",
      spuNum:"商品编号",
      shopName:"店铺名称",
      productName:"商品名称"
    },
    shopInfo:{
      conter:"联系人：",
      tel:"联系电话："
    },
    HotSale:{
      title:"商家热销",
      money:"元",
      saleCount:"已售",
      saleCountunit:"笔",
      egotiable:"面议",
    },
    Confirm:{
      title:"提示",
      content:"货品已加入进货单",
      confirmButtonText:"去结算",
      cancelButtonText:"继续购物"
    },
    Message:{
      hasSpecarrNoselect:"未选中规格",
      collectSuc:"收藏成功",
      collectDel:"取消收藏成功",
      shopCollect:"关注成功",
      shopCollectDel:"取消关注成功",
    },
    baseDetails:{
      baseName:"基地名称",
      baseCertification:"基地认证",
      output:"年产量",
      unit:"公斤",
      click:"点击查看",
    },
    TabsName:{
      tab1:"商品详情",
      tab2:"基地信息",
      tab3:"产品资质",
      tab4:"检测报告",
      tab5:"品质评价",
      tab6:"交易说明",
      tab21:"部分示范基地"
    }
    
  }
  
}